// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cont-import-GS-box {
    position: relative;
    display: block;
    width: 90%;
    height: 90%;
    

  }
.row-cont-input-file{
    position: relative;
    display: flex;
    width: 100%;
    height: 15%;
    justify-content: start;
    align-items: center;
    /* background: blue; */
}
.row-cont-input-table{
    position: relative;
    display: block;
    width: 100%;
    height: 70%;
    justify-content: center;
    align-items: center;
    
}
.border-table{
    border:1px solid var(--border-table-color);
    border-radius: var(--border-radios-small);
    height: 90%;
}
.msgImport{
    display: flex;
    justify-content: center;
    align-items: center;
    color: var(--txt-color);
    font-size: var(--font-size-small);
}
.txtCantData{
    height: 10%;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: var(--txt-color);
    font-size: var(--font-size-small);
}
.row-cont-input-buttons{
    position: relative;
    display: flex;
    width: 100%;
    height: 15%;
    /* background: green; */
}


.file-input-container {
    display: flex;
    align-items: center;
  }
  
  .custom-file-button {
    background-color: #007bff;
    color: white;
    border: none;
    height: 4vh;
  width: 20vh;
  font-size: var(--font-size-small);
  font-weight: bold;
    /* padding: 10px 20px; */
    border-radius: 5px;
    cursor: pointer;
    font-size: var(--font-size-small);
    transition: background-color 0.3s ease;
  }
  
  .custom-file-button:hover {
    background-color: #0056b3;
  }
  
  #file-name {
    margin-left: 10px;
    font-size: 14px;
    color: #666;
  }

  .table-import{
    border:1px solid var(--border-table-color);
    border-radius: var(--border-radios-small);
    height: 100%;
    position: relative;
    width: 80%;
    background-color: red;
  }
  .table-import-head{
    border:1px solid var(--border-table-color);
    border-radius: var(--border-radios-small);
    height: 100%;
    position: relative;
    width: 80%;
    background-color: red;
  }`, "",{"version":3,"sources":["webpack://./src/components/encuestas-components/Encuestas/styles/ImportInfo.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,cAAc;IACd,UAAU;IACV,WAAW;;;EAGb;AACF;IACI,kBAAkB;IAClB,aAAa;IACb,WAAW;IACX,WAAW;IACX,sBAAsB;IACtB,mBAAmB;IACnB,sBAAsB;AAC1B;AACA;IACI,kBAAkB;IAClB,cAAc;IACd,WAAW;IACX,WAAW;IACX,uBAAuB;IACvB,mBAAmB;;AAEvB;AACA;IACI,0CAA0C;IAC1C,yCAAyC;IACzC,WAAW;AACf;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,uBAAuB;IACvB,iCAAiC;AACrC;AACA;IACI,WAAW;IACX,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,uBAAuB;IACvB,iCAAiC;AACrC;AACA;IACI,kBAAkB;IAClB,aAAa;IACb,WAAW;IACX,WAAW;IACX,uBAAuB;AAC3B;;;AAGA;IACI,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,WAAW;EACb,WAAW;EACX,iCAAiC;EACjC,iBAAiB;IACf,wBAAwB;IACxB,kBAAkB;IAClB,eAAe;IACf,iCAAiC;IACjC,sCAAsC;EACxC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,WAAW;EACb;;EAEA;IACE,0CAA0C;IAC1C,yCAAyC;IACzC,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,qBAAqB;EACvB;EACA;IACE,0CAA0C;IAC1C,yCAAyC;IACzC,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,qBAAqB;EACvB","sourcesContent":[".cont-import-GS-box {\r\n    position: relative;\r\n    display: block;\r\n    width: 90%;\r\n    height: 90%;\r\n    \r\n\r\n  }\r\n.row-cont-input-file{\r\n    position: relative;\r\n    display: flex;\r\n    width: 100%;\r\n    height: 15%;\r\n    justify-content: start;\r\n    align-items: center;\r\n    /* background: blue; */\r\n}\r\n.row-cont-input-table{\r\n    position: relative;\r\n    display: block;\r\n    width: 100%;\r\n    height: 70%;\r\n    justify-content: center;\r\n    align-items: center;\r\n    \r\n}\r\n.border-table{\r\n    border:1px solid var(--border-table-color);\r\n    border-radius: var(--border-radios-small);\r\n    height: 90%;\r\n}\r\n.msgImport{\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    color: var(--txt-color);\r\n    font-size: var(--font-size-small);\r\n}\r\n.txtCantData{\r\n    height: 10%;\r\n    width: 100%;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    color: var(--txt-color);\r\n    font-size: var(--font-size-small);\r\n}\r\n.row-cont-input-buttons{\r\n    position: relative;\r\n    display: flex;\r\n    width: 100%;\r\n    height: 15%;\r\n    /* background: green; */\r\n}\r\n\r\n\r\n.file-input-container {\r\n    display: flex;\r\n    align-items: center;\r\n  }\r\n  \r\n  .custom-file-button {\r\n    background-color: #007bff;\r\n    color: white;\r\n    border: none;\r\n    height: 4vh;\r\n  width: 20vh;\r\n  font-size: var(--font-size-small);\r\n  font-weight: bold;\r\n    /* padding: 10px 20px; */\r\n    border-radius: 5px;\r\n    cursor: pointer;\r\n    font-size: var(--font-size-small);\r\n    transition: background-color 0.3s ease;\r\n  }\r\n  \r\n  .custom-file-button:hover {\r\n    background-color: #0056b3;\r\n  }\r\n  \r\n  #file-name {\r\n    margin-left: 10px;\r\n    font-size: 14px;\r\n    color: #666;\r\n  }\r\n\r\n  .table-import{\r\n    border:1px solid var(--border-table-color);\r\n    border-radius: var(--border-radios-small);\r\n    height: 100%;\r\n    position: relative;\r\n    width: 80%;\r\n    background-color: red;\r\n  }\r\n  .table-import-head{\r\n    border:1px solid var(--border-table-color);\r\n    border-radius: var(--border-radios-small);\r\n    height: 100%;\r\n    position: relative;\r\n    width: 80%;\r\n    background-color: red;\r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
